import ActivityData from './data';

const normalizeHref = (link: string) => {
  const clean = link.trim();
  return /^https?:\/\//i.test(clean) ? clean : `https://${clean}`;
};

const ActivitiesAndAttractions = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">The Lakes Region</span>
          <h2>So much to explore, all close by.</h2>
          <p>
            Skiing, hiking, water parks, scenic railroads, museums and more — the White Mountains
            and Newfound Lake area are packed with things to do for every age and interest.
          </p>
        </div>

        <div className="activities-cols">
          {ActivityData.map((activity) => (
            <section className="activity-cat" key={activity.name}>
              <h3>
                {activity.name.trim()}
                <span className="n">{activity.attractions.length}</span>
              </h3>
              <ul>
                {activity.attractions.map((attraction) => (
                  <li key={attraction.name + attraction.link}>
                    <a href={normalizeHref(attraction.link)} target="_blank" rel="noreferrer">
                      <span>{attraction.name}</span>
                      <span className="go" aria-hidden>↗</span>
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ActivitiesAndAttractions;
